import { BingoService } from '../../../shared/src/services/bingo.service';

export const InGameService = {
    getGameMode(isLoggedIn) {
        return isLoggedIn ? 'M' : 'D';
    },

    openGame({
        gameId,
        gamesById,
        isLoggedIn,
        dispatch,
        closeAndLoadGame,
        showRegistration,
    }) {
        let game = gamesById[gameId];
        if (isLoggedIn || !isLoggedIn && game.playModes.includes('Demo')) {

            if (!BingoService.isBingoRoom(game) && !BingoService.isBingoLobby(game)) {
                document.body.classList.add('pass-trough-game', 'start-in-game');
            }

            dispatch(closeAndLoadGame({
                gameId: game.id,
                mode: this.getGameMode(isLoggedIn),
            }));
        } else {
            dispatch(showRegistration());
        }
    }
};
